import { format } from "lib/globalize-util";
import { emailRegExp } from "lib/validators";

export const validationRules = {
    required: ({ fieldName }: { fieldName: string }) => format("{fieldName} is required", { fieldName }),
    maxLength: ({ value }) => ({
        value,
        message: format("Input exceeds the character limit of {value}", { value }),
    }),
    email: ({ value = emailRegExp }: { value?: RegExp } = {}) => ({
        value,
        message: format("Enter a valid email"),
    }),
};
